<app-loader-page></app-loader-page>
<router-outlet></router-outlet>